export { default } from "./TabBar-component";
